import React, { useMemo } from 'react'
import { UserCircleIcon } from '@heroicons/react/24/outline'
import { useAuth } from '../contexts/AuthContext'

const Home: React.FC = () => {
  const { user } = useAuth()

  const displayName = useMemo(() => {
    if (!user) return ''
    const full = `${user.first_name || ''} ${user.last_name || ''}`.trim()
    const titled =
      full.replace(/\b\w/g, (l) => l.toUpperCase()) ||
      (user.email ? user.email.split('@')[0] : '')
    return titled || 'Usuario'
  }, [user])

  const userInitials = useMemo(() => {
    if (!user) return 'U'
    const firstInitial = user.first_name?.charAt(0).toUpperCase() || ''
    const lastInitial = user.last_name?.charAt(0).toUpperCase() || ''
    return `${firstInitial}${lastInitial}` || 'U'
  }, [user])

  const roleLabel = useMemo(() => {
    if (!user) return ''
    return (user.role_name || user.role || '').trim()
  }, [user])

  if (!user) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center min-h-[320px] bg-white rounded-lg shadow-sm border border-gray-100">
          <div className="text-center px-4">
            <UserCircleIcon className="h-16 w-16 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 text-sm">
              No hay información de usuario disponible
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-200">
        <div className="flex items-center gap-6">
          <div className="relative shrink-0">
            <div className="h-20 w-20 sm:h-24 sm:w-24 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-lg">
              <span className="text-xl sm:text-2xl font-bold text-white">
                {userInitials}
              </span>
            </div>
            <div className="absolute bottom-0 right-0 h-5 w-5 sm:h-6 sm:w-6 bg-green-500 rounded-full border-2 border-white shadow-sm flex items-center justify-center">
              <div className="h-1.5 w-1.5 sm:h-2 sm:w-2 bg-white rounded-full" />
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-gray-500 mb-1">Bienvenido</p>
            <p className="text-2xl font-semibold text-gray-900 mb-1 truncate">
              Hola, {displayName}
            </p>
            <p className="text-sm text-gray-500 truncate">{user.email}</p>
            {roleLabel ? (
              <span
                className="inline-block mt-2 px-3 py-1 text-xs font-medium bg-blue-50 text-blue-700 rounded-full border border-blue-100 max-w-full truncate"
                title={roleLabel}
              >
                {roleLabel}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
